import ApiService from "@/core/services/ApiService";

class RepmanService {

    public static getData(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/repman', data)
    }

}

export default RepmanService;